<script>
import { MapAgentStationStatus } from "@/common/util";
import PagenationContainer from "@/components/common/PagenationContainer.vue";

import cloneDeep from "lodash/cloneDeep";
import forOwn from "lodash/forOwn";
import moment from "moment";
export default {
  components: {
    PagenationContainer
  },
  data() {
    const ROLE_AGENT =
      localStorage.getItem("roles").indexOf("ROLE_AGENT") > -1 &&
      !(localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1);
    const ROLE_AGENT_MANAGER = localStorage.getItem("roles").indexOf("ROLE_AGENT_MANAGER") > -1;
    const ROLE_REGION_MANAGER =
      localStorage.getItem("roles").indexOf("ROLE_REGION_MANAGER") > -1;
    let tmpSearchForm = {auditFlag: ""};
    return {
      ROLE_AGENT,
      ROLE_AGENT_MANAGER,
      ROLE_REGION_MANAGER,
      ProvinceList: [],
      // addReqFlag: false,
      reviewPassFlag: false,
      reviewRejectFlag: false,
      // addNewReqArr:[
      //   {label: "购满", keyName: "condition", type: "input", value:""},
      //   {label: "赠送", keyName: "complimentary", type: "input", value:""}
      // ],
      searchFormData:tmpSearchForm,
      activeSearchArray: [
        {
          label: "授权",
          keyName: "auditFlag",
          type: "select",
          value: tmpSearchForm.auditFlag,
          children: [
            {
              label: "全部",
              keyName: ""
            },
            {
              label: "待审核",
              keyName: "WAITING"
            },
            {
              label: "审核通过",
              keyName: "PASS"
            },
            {
              label: "已拒绝",
              keyName: "REJECT"
            }
          ]
        }
      ],
      tableData: [],
      defaultValue: {},
      pageCount: 0,
      activePage: 1,
      totalElements: 0
    };
  },
  created() {
    // this.loadProvice();
    this.loadData();
  },
  methods: {
    async loadData() {
      let params = {
        page: this.activePage - 1
      };
      console.log("searchFormData");
      console.log(this.searchFormData);
      for (let key in this.searchFormData) {
        console.log("key:" + key);
        if (key === "provinceCity") {
          if (this.searchFormData[key]) {
            if (this.searchFormData[key][0]) {
              params.provinceId = this.searchFormData[key][0];
            }
            if (this.searchFormData[key][1]) {
              params.districtId = this.searchFormData[key][1];
            }
          }
        } else if (this.searchFormData[key]) {
          params[key] = this.searchFormData[key];
        }
      }
      let data = await this.$http.findSalesPromotions(params);
        if (data && data.content) {
          this.pageCount = data.totalPages;
          this.totalElements = data.totalElements;
          let newTableData = [];
          data.content.forEach(item => {
            newTableData.push({
              createdAt: moment(item.createdAt).format("YYYY-MM-DD"),
              agentUserId: item.agentUserid,
              agentUserName: item.agentUserName,
              agentName: item.agentName,
              stationName: item.stationName,
              id: item.id,
              auditStatus: item.auditStatus, 
              auditFlagDesc: item.auditStatus === 'WAITING' ? '待审核' : (item.auditStatus === 'PASS' ? '已通过' : '已拒绝'),
              title: '满' + item.condition + '赠' + item.complimentary,
              condition: item.condition,
              complimentary: item.complimentary
            });
          });
          this.tableData = newTableData;
        }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.activePage = val;
      this.loadData();
    },
    onSearch() {
      this.activePage = 1;
      this.loadData();
    },
    async loadProvice() {
      let ProvinceList = [];
      let province = [];
      if (this.ROLE_REGION_MANAGER) {
        ProvinceList = await this.$http.getProvinceList("regionManager");
        province = this.activeSearchArray;
      }
      if (ProvinceList.length > 0) {
        const provinceChildren = ProvinceList.map(o => {
          return {
            label: o.name,
            keyName: o.id,
            value: o.id,
            children: o.sons.map(o => {
              return {
                label: o.name,
                value: o.id
              };
            }),
            id: o.id,
            name: o.name
          };
        });
        province.forEach(o => {
          if (o.keyName === "provinceCity") {
            o.children = provinceChildren;
          }
        });
        this.ProvinceList = provinceChildren;
      }
    },
    onSearchChange(data) {
      forOwn(data, (value, key) => {
        this.searchFormData[key] = data[key];
      });
    },
    // async onAddReq(params) {
    //   // console.log(params);
    //   console.log("save sales promotions")
    //   await this.$http.saveSalesPromotions(params);
    //   this.addReqFlag = false;
    // },
    async reqAudit(id, flag) {
      await this.$http.updateSalesPromotionAuditFlag({id: id, auditFlag: flag});
      this.loadData();
    }
  }
};
</script>
<template>
  <div class="salesPromotionIndex">
    <!-- <DialogForm
      v-if="addReqFlag"
      formTitle="促销申请"
      :formInputArray="addNewReqArr"
      @close="addReqFlag = false"
      @submitForm="onAddReq"
      keyOperation="addMyReq"
    /> -->
    <DialogForm
      v-if="reviewPassFlag"
      :defaultValue="defaultValue"
      formTitle="请确认通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAuditFlag"
      keyOperation="true"
      confirmButton="确认"
    />
    <DialogForm
      v-if="reviewRejectFlag"
      :defaultValue="defaultValue"
      formTitle="请确认拒绝通过审核"
      @close="onClickCancel"
      @submitForm="onUpdateAuditFlag"
      keyOperation="false"
      confirmButton="确认"
    />
    <searchFormNew
      class="searchForm"
      showSearch
      @onSearch="onSearch"
      @onChange="onSearchChange"
      :searchItemArray="activeSearchArray"
    />
    <!-- <elementButton
      class="AddAgentButton"
      style = "margin:18px 18px 0"
      v-if="ROLE_AGENT_MANAGER || ROLE_AGENT"
      @click="addReqFlag = true"
      size="medium"
      type="primary"
    >促销申请</elementButton> -->
    <div class="statistics">
      <i class="el-icon-info totalResult"></i>
      查询结果：
      <span class="totalResult">{{totalElements}}</span> 个
    </div>
    <el-table
      :data="tableData"
      class="impowerTable"
      :header-cell-style="{ 'padding-left': '5px',color: 'rgba(0,0,0,0.65)','font-size': '14px', 'background-color': '#fafafa !important'}"
      :cell-style="{'padding-left': '5px'}"
    >
      <el-table-column prop="title" align="left" label="促销活动名"></el-table-column>
      <el-table-column prop="agentName" align="left" label="代理商" width="200"></el-table-column>
      <el-table-column prop="stationName" align="left" label="机构" width="200"></el-table-column>
      <el-table-column prop="agentUserName" align="left" label="申请人" width="120"></el-table-column>
      <el-table-column prop="auditFlagDesc" align="left" label="状态" width="200">
      </el-table-column>
      <el-table-column
        v-if="ROLE_REGION_MANAGER"
        prop="operation"
        min-width="290"
        label="操作"
      >
      <template slot-scope="scope">
        <span class="textButton">
          <el-button type="text" size="small" @click.stop="reqAudit(scope.row.id, true)">授权</el-button>
          <el-button type="text" size="small" @click.stop="reqAudit(scope.row.id, false)">拒绝</el-button>
        </span>
      </template>
      </el-table-column>
    </el-table>
    <PagenationContainer v-if="pageCount > 1">
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :current-page="activePage"
        :page-count="pageCount"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </PagenationContainer>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.salesPromotionIndex {
  .line {
    width: auto;
    height: 1px;
    background-color: #ebebeb;
    margin: 15px 0;
  }

  .searchForm {
    border: 1px;
    padding-top: 15px;
    height: 50px;
    margin: 0 1%;
    // float: left;
  }
  .statistics {
    float: right;
    margin-right: 30px;
    margin-bottom: 10px;
    // padding-top: 15px;
    margin-top: 10px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 22px;
    .totalResult {
      color: #00c1de;
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 10px;
  }

  .impowerTable {
    margin: 20px 1%;
    border: 1px;
    width: 98%;
    .el-table__body tr:hover > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }

    .el-table__body tr.current-row > td {
      background-color: #e6f7ff !important;
      cursor: pointer;
    }
    th > .cell {
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/patientPromotion/index.vue